import { render, staticRenderFns } from "./GasTransport.vue?vue&type=template&id=991ba126"
import script from "./GasTransport.vue?vue&type=script&lang=js"
export * from "./GasTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports